import styles from "./ErrorMessage.module.css";

const ErrorMessage = ({ value }) => {
  return value ? <p className={styles.errorMessage}>{value}</p> : null;
};

export default ErrorMessage;
